module.exports = __webpack_public_path__ + "assets/img/CDC_Icon.c3464e3d.png";